import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';

@Module({ namespaced: true })
export default class Auth extends VuexModule {
  currentUser: any = null;
  tenant: any = null;

  @Mutation
  SET_CURRENT_USER(user: any) {
    this.currentUser = user;
  }

  @Mutation
  UNSET_CURRENT_USER() {
    this.currentUser = null;
  }

  @Mutation
  SET_CURRENT_TENANT(tenant: any) {
    this.tenant = tenant;
  }

  get currentUsername() {
    return this.currentUser ? this.currentUser.username : null;
  }

  get currentLoggedinUser() {
    return this.currentUser;
  }

  get currentTenants() {
    return this.currentUser &&
      this.currentUser.content &&
      this.currentUser.content.tenants
      ? this.currentUser.content.tenants
      : null;
  }

  get currentTenant() {
    return this.tenant || null;
  }

  get isMaintainer() {
    return this.currentUser.content.profileIds.some((match: string) =>
      RegExp('^hyvision-\\w+-(?:admin|maintainer)$|^admin$').test(match)
    );
  }

  get isAdmin() {
    return this.currentUser.content.profileIds.some((match: string) =>
      RegExp('^hyvision-\\w+-admin$|^admin$').test(match)
    );
  }

  get isCustomer() {
    return this.currentUser.content.profileIds.some((match: string) =>
      RegExp('^hyvision-\\w+-customer$').test(match)
    );
  }

  @Action
  async LOGIN(payload: { credentials: any; kuzzle: any }) {
    let jwt;
    try {
      jwt = await payload.kuzzle.auth.login(
        'local',
        payload.credentials,
        '7 days'
      );
      await this.context.dispatch('FETCH_CURRENT_USER', payload.kuzzle);
    } catch (error) {
      localStorage.removeItem('user_token');
      localStorage.removeItem('current_tenant');
      throw error;
    }

    localStorage.setItem('user_token', jwt);
  }

  @Action
  async CHECK_TOKEN(kuzzle: any) {
    const jwt = localStorage.getItem('user_token');

    if (!jwt) {
      return false;
    }

    const { valid } = await kuzzle.auth.checkToken(jwt);

    if (!valid) {
      await this.context.dispatch('LOG_OUT', kuzzle);
      return false;
    }

    kuzzle.jwt = jwt;

    if (!this.currentUser) {
      await this.context.dispatch('FETCH_CURRENT_USER', kuzzle);
    }

    return true;
  }

  @Action
  async FETCH_CURRENT_USER(kuzzle: any) {
    let currentUser;
    try {
      const [credentials, rights, { content }] = await Promise.all([
        kuzzle.auth.getMyCredentials('local'),
        kuzzle.auth.getMyRights(),
        kuzzle.auth.getCurrentUser()
      ]);

      currentUser = credentials;
      currentUser.rights = rights;
      currentUser.content = content;
    } catch (error) {
      throw error;
    }

    this.context.commit('SET_CURRENT_USER', currentUser);

    if (currentUser.content.tenants) {
      const currentTenant = localStorage.getItem('current_tenant');
      let tenant = currentUser.content.tenants[0];

      if (currentTenant) {
        const foundTenant = this.currentTenants.find(
          (item: { index: string }) => item.index === currentTenant
        );
        if (foundTenant) {
          tenant = foundTenant;
        }
      }

      this.context.commit('SET_CURRENT_TENANT', tenant);
    }

    /**
     * Here, you can perform some data fetch related to your user-session.
     */
  }

  @Action
  async SET_TENANT(index: string) {
    const tenant = this.currentTenants.find(
      (item: { index: string }) => item.index === index
    );
    this.context.commit('SET_CURRENT_TENANT', tenant);
    localStorage.setItem('current_tenant', index);
  }

  @Action
  async LOG_OUT(kuzzle: any) {
    /**
     * You should tear down your session here.
     */
    this.context.commit('UNSET_CURRENT_USER');
    kuzzle.jwt = null;
    localStorage.removeItem('user_token');
    localStorage.removeItem('current_tenant');
  }
}
